import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=b0b8337e&scoped=true"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"
import style0 from "./Info.vue?vue&type=style&index=0&id=b0b8337e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b8337e",
  null
  
)

export default component.exports